import { cva } from 'class-variance-authority';
export const toggleItem = cva([''], {
    variants: {
        position: {
            first: 'rounded-l-lg rounded-r-none data-[state=off]:border-r-transparent',
            last: 'rounded-r-lg rounded-l-none data-[state=off]:border-l-transparent',
            middle: '!rounded-none',
        },
    },
});
